import { createMutation } from "@/api/utils";
import { ensureHttps } from "@/utils/misc/formattedUrl";
import { MemoText, MemoTextTypeEnum } from "./MemoText.model";

export const generateMemoText = createMutation<
    MemoText[],
    {
        companyWebsite: string | undefined;
    }
>(
    async ({ api, router, payload }) => {
        const response = await api.post(
            `/deal-flow/alpha/companies/${router.params.companyId}/memo-texts/generate`,
            {
                companyWebsite: payload.companyWebsite
                    ? ensureHttps(payload.companyWebsite)
                    : "",
            },
        );

        return response.items.map((item) => ({
            ...item,
            type: item.id as MemoTextTypeEnum,
        }));
    },
    {
        invalidates: ["/memo-texts"],
        errorToast: {
            message: "Unable to generate memo text.",
        },
    },
);
